<template>
  <div class="md-layout">
    <div class="md-layout-item md-layout md-size-100" v-for="section in sections" :key="section.id" >
      <div :ref="section.id" class="md-layout-item handbook-section" v-bind:style="sectionStyle(section)">
        <img :src="section.image" v-if="showImage(section)" v-bind:style="imageStyle(section)"/>
        <p v-html="section.body"></p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default{
  name: "HandbookSections",
  computed: {
    ...mapState({
      sections: s => s.handbook.sections.sort(function(a, b){ return (a.order - b.order) })
    })
  },
  methods: {
    scrollTo(id) {
      return this.$refs[id][0].offsetTop
    },
    sectionStyle (section) {
      return { 
        'background': this.sectionBackgroundStyle(section),
        'color': section.font_color_hex, 
        'font-family': section.font
      }
    },
    sectionBackgroundStyle(section) {
      let image = (( section.placement && section.image && section.placement === 'background' )? `url(${section.image}) center/cover` : '')
      let color = ((section.bg_color_hex)? section.bg_color_hex : '')
      return `${color} ${image}`
    },
    imageStyle(section) {
      if(section.placement === 'left' || section.placement === 'right'){
        return { 'float': section.placement, 'margin': '10px' }
      }else{
        return {}
      }
    },
    showImage(section) {
      return section.image && section.placement != 'background'
    }
  }
}
</script>
<style>
.handbook-section{
  min-height: 100vh;
  padding: 20px;
  line-height: 225%;
}
.ql-align-center{
  text-align: center;
}
.ql-align-right{
  text-align: right;
}
.ql-align-justify{
  text-align: justify;
}
</style>
